<div class="min-h-screen bg-surface flex flex-col justify-center py-12 sm:px-6 lg:px-8">
  <div class="sm:mx-auto sm:w-full sm:max-w-md">
    <img
      style="filter: invert(100%)"
      class="mx-auto h-12 w-auto"
      src="/assets/jessie-logo.png"
      alt="Workflow"
    />
    <h2 class="mt-6 text-center text-3xl leading-9 font-extrabold text-fg-primary">
      Logge Dich hier ein
    </h2>
  </div>

  <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
    <div class="bg-surface py-8 px-4 shadow sm:rounded-lg sm:px-10">
      <form [formGroup]="loginForm" autocomplete="on">
        <app-text-input
          label="Email Adresse"
          [formControl]="loginForm.controls.mailAddress"
          autocomplete="email"
        >
        </app-text-input>

        <div class="mt-6">
          <button
            class="w-full justify-center"
            (click)="login()"
            appTailwindButton
            [disabled]="disableButton"
          >
            Anmelden
          </button>
        </div>
      </form>
    </div>
  </div>

  @if (showErrorDialog) {
    <app-dialog
      icon="heroExclamationCircle"
      color="red"
      [title]="error"
      description=""
      actionText="Zurück zum Login"
      (actionClicked)="closeModal()"
    ></app-dialog>
  }

  @if (showWaitDialog) {
    <app-dialog
      title="Magic Link verschickt"
      description="Check deinen E-Mail Eingang und klicke auf den Login Link!"
      actionText="Zurück zum Login"
      (actionClicked)="closeModal()"
    ></app-dialog>
  }
</div>
